import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  _Duration___get_inWholeMicroseconds__impl__8oe8vv3ftjral8oy9p8 as _Duration___get_inWholeMicroseconds__impl__8oe8vv,
  Duration__toString_impl_8d916b1pmuuqkmfodll as Duration__toString_impl_8d916b,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { toNumber2e2hj9zugjwi2 as toNumber } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { ActionWrapper2ie29abg6ehro as ActionWrapper } from '../../../../../testmints-action-async/com/zegreatrob/testmints/action/ActionWrapper.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Monotonic_instancewn07e60bp6rj as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs31ikzp5dku7pk as ValueTimeMark__elapsedNow_impl_eonqvs,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/TimeSource.mjs';
import { $3l5vvh8yg0ier as $ } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { TimedValuew9j01dao9jci as TimedValue } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/measureTime.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function logStart($this, className) {
  var tmp = $this.c2l();
  return tmp.v2h(() => mapOf([to('command_action', className), to('command_phase', 'start'), to('command_trace_id', $this.d2l()), to('action', className), to('type', 'Start'), to('traceId', $this.d2l())]));
}
function logEnd($this, className, duration) {
  var tmp = $this.c2l();
  return tmp.v2h(() => {
    var durationMs = toNumber(_Duration___get_inWholeMicroseconds__impl__8oe8vv(duration)) / 1000.0;
    return mapOf([to('command_action', className), to('command_phase', 'end'), to('command_trace_id', $this.d2l()), to('command_duration_ms', durationMs), to('action', className), to('type', 'End'), to('duration', Duration__toString_impl_8d916b(duration)), to('traceId', $this.d2l())]);
  });
}
function logException($this, exception, className) {
  var tmp = $this.c2l();
  return tmp.x2h(exception, () => {
    var tmp = to('command_action', className);
    var tmp_0 = to('command_phase', 'end');
    var tmp_1 = to('command_trace_id', $this.d2l());
    var tmp_2 = to('command_error', !(exception instanceof CancellationException()));
    return mapOf([tmp, tmp_0, tmp_1, tmp_2, to('command_cancelled', exception instanceof CancellationException()), to('action', className), to('type', 'End'), to('traceId', $this.d2l())]);
  });
}
function *logAsync(action, block, $completion) {
  // Inline function 'com.zegreatrob.coupling.action.ActionLoggingSyntax.logBlock' call
  var tmp;
  if (isInterface(action, ActionWrapper())) {
    tmp = getKClassFromExpression(action.c2h()).j1();
  } else {
    tmp = getKClassFromExpression(action).j1();
  }
  var actionName = tmp;
  logStart(this, actionName);
  var tmp_0;
  try {
    // Inline function 'com.zegreatrob.coupling.action.ActionLoggingSyntax.runBlock' call
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.time.measureTimedValue' call
    var mark = Monotonic_instance.di();
    var result = yield* $(block(action, $completion), $completion);
    var result_0 = new (TimedValue())(result, ValueTimeMark__elapsedNow_impl_eonqvs(mark));
    var duration = result_0.rt_1;
    logEnd(this, actionName, duration);
    tmp_0 = result_0.qt_1;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof Exception()) {
      var exception = $p;
      logException(this, exception, actionName);
      throw exception;
    } else {
      throw $p;
    }
  }
  return tmp_0;
}
var ActionLoggingSyntaxClass;
function ActionLoggingSyntax() {
  if (ActionLoggingSyntaxClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ActionLoggingSyntax', VOID, VOID, VOID, [2]);
    ActionLoggingSyntaxClass = $;
  }
  return ActionLoggingSyntaxClass;
}
//region block: exports
export {
  ActionLoggingSyntax as ActionLoggingSyntax2p3dfvwppstk6,
  logAsync as logAsync36io0s5hscp3c,
};
//endregion

//# sourceMappingURL=ActionLoggingSyntax.mjs.map
